/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
export const actions = {
  USERS_LOADING: "USERS/LOADING",
  USERS_SUCCESS: "USERS/SUCCESS",
  USERS_FAILED: "USERS/FAILED",
  COMPANIONS_LOADING: "COMPANIONS/LOADING",
  COMPANIONS_SUCCESS: "COMPANIONS/SUCCESS",
  GROUPS_LOADING: "GROUPS/LOADING",
  GROUPS_SUCCESS: "GROUPS/SUCCESS",
  GROUPS_FAILED: "GROUPS/FAILED",
};

export const usersLoading = () => ({
  type: actions.USERS_LOADING,
});

export const usersSuccess = (users, groupId) => ({
  type: actions.USERS_SUCCESS,
  payload: { users, groupId },
});

export const companionsLoading = () => ({
  type: actions.COMPANIONS_LOADING,
});

export const companionsSuccess = (companions, userId) => ({
  type: actions.COMPANIONS_SUCCESS,
  payload: { companions, userId },
});

export const usersFailed = () => ({
  type: actions.USERS_FAILED,
});

export const groupsLoading = () => ({
  type: actions.GROUPS_LOADING,
});

export const groupsSuccess = (groups) => ({
  type: actions.GROUPS_SUCCESS,
  payload: groups,
});

export const groupsFailed = () => ({
  type: actions.GROUPS_FAILED,
});
